document.addEventListener('alpine:init', () => {
  Alpine.data('rotatingMedia', () => ({
    offset: 0,
    speed: 0.5,
    singleSetWidth: 0,

    init() {
      this.track = this.$el.querySelector('.rotating-media__inner');

      setTimeout(() => {
        this.singleSetWidth = this.track.scrollWidth / 2;
        requestAnimationFrame(this.animate.bind(this));
      }, 200);
    },

    animate() {
      this.offset -= this.speed;

      if (Math.abs(this.offset) >= this.singleSetWidth) {
        this.offset = 0;
      }

      this.track.style.transform = `translateX(${this.offset}px)`;

      requestAnimationFrame(this.animate.bind(this));
    },
  }));
});
